"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Label_1 = __importDefault(require("../components/Label"));
var InputField_1 = __importDefault(require("./InputField"));
var SDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (_a) {
    var noStyles = _a.noStyles;
    return !noStyles && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-top: 6px;\n      margin-bottom: 20px;\n    "], ["\n      margin-top: 6px;\n      margin-bottom: 20px;\n    "])));
});
var TextFieldLabeled = function (_a) {
    var name = _a.name, label = _a.label, size = _a.size, readOnly = _a.readOnly, toolTip = _a.toolTip, noStyles = _a.noStyles, maxLength = _a.maxLength, placeholder = _a.placeholder;
    return (react_1.default.createElement("div", null,
        label && react_1.default.createElement(Label_1.default, { htmlFor: name }, label),
        react_1.default.createElement(SDiv, { noStyles: noStyles },
            react_1.default.createElement(InputField_1.default, { name: name, size: size, readOnly: readOnly, toolTip: toolTip, maxLength: maxLength, placeholder: placeholder }))));
};
TextFieldLabeled.defaultProps = {
    size: undefined,
    label: undefined,
    readOnly: false,
    toolTip: undefined,
    noStyles: false,
    maxLength: undefined,
    placeholder: undefined,
};
exports.default = TextFieldLabeled;
var templateObject_1, templateObject_2;
